import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

/* Utilities */
import { randomString } from 'util/string'

/* Styles */
import './index.css'


/* Single Playlist List Item */
export default class Thumbnail extends Component {

    getClassName() {
        const {
            className
        } = this.props
        let classNameArr = className ?className.split(' '):[]
        classNameArr.push('thumbnail', 'widget')
        return  classNameArr.join(' ')
    }

    renderIcon() {
          const { src } =  this.props
          return ( <img src={src} /> )
    }

    render() {
        const {
            uid,
            onClick,
            onFocus,
            title
        } = this.props
        return (
          <button
            className={ this.getClassName() }
            onClick={ onClick }
            onFocus={ onFocus }
            title={ title }
            >
            { this.renderIcon() }
          </button>
        )
    }
}

Thumbnail.propTypes = {
    src: PropTypes.string,
    uid: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/app/widget/thumbnail/index.jsx